import { ApiRoutes } from "@/lib/routes";

import CreateRiskStore from "@/areas/risks/stores/CreateRiskStore";
import BrowseRisksStore from "@/areas/risks/stores/BrowseRisksStore";
import ExportRisksStore from "@/areas/risks/stores/ExportRisksStore";
import RiskHeatmapStore from "@/areas/risks/stores/RiskHeatmapStore";
import RiskCalendarStore from "@/areas/risks/stores/RiskCalendarStore";
import BrowseTreatmentsStore from "@/areas/risks/stores/BrowseTreatmentsStore";
import ExportTreatmentsStore from "@/areas/risks/stores/ExportTreatmentsStore";
import BrowseRiskWatchlistStore from "@/areas/risks/stores//BrowseRiskWatchlistStore";

import BrowseTargetRolesStore from "@/areas/subscriptions/stores/BrowseTargetRolesStore";
import BrowseTargetFieldsStore from "@/areas/fields/stores/BrowseTargetFieldsStore";
import BrowseRisksSummaryStore from "@/areas/risks/stores/BrowseRisksSummaryStore";

import BrowseTreatmentsSummaryStore from "./BrowseTreatmentsSummaryStore";
import RiskMatrixConfigurationStore from "./RiskMatrixConfigurationStore";

export default class RiskRootStore {
  constructor(parentStore) {
    this.parentStore = parentStore;

    this.createRiskStore = new CreateRiskStore(this);
    this.browseRisksStore = new BrowseRisksStore(this);
    this.exportRisksStore = new ExportRisksStore(this);
    this.browseRisksSummaryStore = new BrowseRisksSummaryStore(this);
    this.riskHeatmapStore = new RiskHeatmapStore(this);
    this.riskCalendarStore = new RiskCalendarStore(this);
    this.browseTreatmentsStore = new BrowseTreatmentsStore(this);
    this.exportTreatmentsStore = new ExportTreatmentsStore(this);
    this.browseTreatmentsSummaryStore = new BrowseTreatmentsSummaryStore(this);
    this.browseRiskWatchlistStore = new BrowseRiskWatchlistStore(this);
    this.riskMatrixConfigurationStore = new RiskMatrixConfigurationStore(this);

    this.browseRolesStore = new BrowseTargetRolesStore(this, ApiRoutes.forRiskRoles("risk"));
    this.browseTreatmentRolesStore = new BrowseTargetRolesStore(this, ApiRoutes.forRiskRoles("treatment"));
    this.browseRiskTypeRolesStore = new BrowseTargetRolesStore(this, ApiRoutes.forRiskRoles("risk-type"));
    this.browseFieldsStore = new BrowseTargetFieldsStore(this, ApiRoutes.forRiskFields());
  }
}
